export const APPAREL_PRODUCT_TYPE_IDS = [
  'dodgy-dooverlackie',
  'chrissy-chungus',
  'gnarly-seesaw',
  'decent-cuppa',
  'grouse-chips',
  'cactus-bizzo',
  'cluey-kookaburra',
  'dinkum-bandicoot',
  'wonky-mozzie',
  'peckish-flannel',
  'ripper-rissole',
  'big-wheelie',
  'chewy-drongo',
  'whinging-magpie',
  'aggro-emu',
  'tall-sock',
  'outback-brolly',
  'sooky-sanga',
  'fair-cuppa',
  'jumping-boot',
  'shouty-pav',
  'flaming-ute',
  'cracker-kangaroo',
  'tall-larrikin',
  'aussie-hooroo',
  'unreal-chinwag',
  'cheeky-cockatoo',
  'bonza-lamington',
  'billowing-parachute',
  'blockish-wrapper',
];
